import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import SedeExternaGrid from './SedeExternaGrid.js'
import SedeExternaAbm from './SedeExternaAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class SedeExterna extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="sedesExternas.administracion_sedes_externas" defaultMessage="Administración de Sedes Externas"/></h3>
      				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={SedeExternaGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <SedeExternaAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <SedeExternaAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <SedeExternaAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
	    );
  	}
}

export default injectIntl(SedeExterna);
